import MainPage from '@/pages/accounts/CMMainPage.vue'
import UserAccounts from '@/pages/accounts/CMAccountMembersPage.vue'
import EditAccounts from '@/pages/accounts/CMEditAccountMember.vue'
import AddAccounts from '@/pages/accounts/CMAddAccountMember.vue'
import AccountsDetail from '@/pages/accounts/CMAccountMemberDetail.vue'
import AddMemberGroupMembersList from '@/pages/accounts/CMAddMemberGroupMembersList.vue'
import AddMemberGroup from '@/pages/accounts/CMAddTeam.vue'
import MemberGroupDetail from '@/pages/accounts/CMMembersGroupDetail.vue'
import EditMemberGroupPage from '@/pages/accounts/CMEditMembersGroup.vue'

export default [
  {
    path: '/account/',
    alias: ['/account/main-page/'],
    component: MainPage
  },
  {
    path: '/accountMembers/',
    alias: ['/account/accountMembers/'],
    component: UserAccounts
  },
  {
    path: '/accountMembers/edit/',
    alias: ['/account/accountMembers/'],
    component: EditAccounts
  },
  {
    path: '/accountMembers/add/',
    component: AddAccounts
  },
  {
    path: '/accountMembers/accountMemberDetail/',
    component: AccountsDetail
  },
  {
    path: '/accountMembers/addMemberGroupMembersList/',
    component: AddMemberGroupMembersList
  },
  {
    path: '/accountMembers/addMemberGroup/',
    component: AddMemberGroup
  },
  {
    path: '/accountMembers/membersGroupDetail/',
    component: MemberGroupDetail
  },
  {
    path: '/accountMembers/editMemberGroup/',
    component: EditMemberGroupPage
  }
]
